import { useEffect, useRef } from "react";
import { getDownloadJob } from "../api/dataPipeline";
import {
  DownloadEntry,
  isJobInFlight,
  useAuthStore,
  useDownloadsStore,
} from "../store";

const POLL_INTERVAL_MS = 5000;

// The /v1/sse DOWNLOAD payload doesn't carry the queue jobId, so we can't
// correlate SSE events back to popup-tracked jobs. We poll the per-job
// status endpoint instead; the bell handles the user-facing notification
// surface from SSE independently.
export default function DownloadsManager() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const jobsMap = useDownloadsStore((s) => s.jobs);
  const applyStatus = useDownloadsStore((s) => s.applyStatus);

  const jobsRef = useRef(jobsMap);
  jobsRef.current = jobsMap;

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    const interval = setInterval(async () => {
      const inFlight: DownloadEntry[] = Object.values(jobsRef.current).filter(
        isJobInFlight,
      );
      if (inFlight.length === 0) return;
      await Promise.all(
        inFlight.map(async (entry) => {
          try {
            const status = await getDownloadJob(entry.jobId);
            applyStatus(entry.jobId, status);
          } catch {
            // swallow; next poll may recover
          }
        }),
      );
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated, applyStatus]);

  return null;
}
